// extracted by mini-css-extract-plugin
export default {"content":"TestIntroduction_content__JIMEj","start-button":"TestIntroduction_start-button__AZuY4"};